import styles from './SocialLinks.module.scss';

export default function SocialLinks({ url, icon, label }) {
  return (
    <a href={`${url}`} aria-label={`Visit our ${label}`} className={`${styles.nav_link_bottom} p-1`}>
      <i aria-hidden="true" />
      <span className={`d-inline ${styles.label}`}>{icon}</span>
    </a>
  );
}
